module.exports = __webpack_public_path__ + "static/a3-5d6f3dfcfa876e9b1c0618492ebdb8c7.png";